module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/rds-2014-09-01.paginators.json
// module id = 589
// module chunks = 0